import type {ISurveyRange} from "../../types/IBuildSurveyParams";
import {parseToNumber} from "./parse_to_number";

const MIN_ROOMS = 1;
const MAX_ROOMS = 5;

export const surveyCalculateRoomsRange = (
    surveyRooms: ISurveyRange<number> | undefined,
    propertyDetailsRooms: number | undefined,
    offerRoomsMin: number | undefined,
    offerRoomsMax: number | undefined,
    filterRooms0: string | undefined,
    filterRooms1: string | undefined,
    doFiltersOrSurveyExist: boolean
): ISurveyRange<number> => {
    const hasOnlyDetails = !doFiltersOrSurveyExist && propertyDetailsRooms !== undefined;
    if (hasOnlyDetails) {
        return {lower: propertyDetailsRooms, upper: propertyDetailsRooms, bounds: "[]"};
    }

    const hasOnlyOffer = !doFiltersOrSurveyExist && offerRoomsMin !== undefined && offerRoomsMax !== undefined;
    if (hasOnlyOffer) {
        return {lower: offerRoomsMin, upper: offerRoomsMax, bounds: "[]"};
    }

    const values: number[] = [];

    if (surveyRooms?.lower) {
        values.push(surveyRooms.lower);
    }

    if (surveyRooms?.upper) {
        values.push(surveyRooms.upper);
    }

    if (propertyDetailsRooms) {
        values.push(propertyDetailsRooms);
    } else {
        // Add offer rooms range to values
        if (offerRoomsMin !== undefined) {
            values.push(offerRoomsMin);
        }

        if (offerRoomsMax !== undefined) {
            values.push(offerRoomsMax);
        }
    }

    const filterRooms0Value = parseToNumber(filterRooms0);
    const filterRooms1Value = parseToNumber(filterRooms1);
    const hasAnyFilterRooms = filterRooms0Value || filterRooms1Value;

    if (filterRooms0Value) {
        values.push(filterRooms0Value);
    } else if (hasAnyFilterRooms) {
        values.push(MIN_ROOMS);
    }

    if (filterRooms1Value) {
        values.push(filterRooms1Value);
    } else if (hasAnyFilterRooms) {
        values.push(MAX_ROOMS);
    }

    const hasNoValues = values.length === 0;
    if (hasNoValues) {
        return surveyRooms || {lower: 1, upper: 5, bounds: "[]"};
    }

    return {
        lower: Math.min(...values),
        upper: Math.max(...values),
        bounds: "[]"
    };
};
